<template>
    <div class="container">
        <md-dialog :md-active.sync="modEditarTipoMoneda" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <!-- <pre>{{ infoTipoMoneda[0] }}</pre> -->
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.codigo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>{{ infoTipoMoneda[0].moneda }}</h5>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoTipoMoneda[0].descripcion" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.acronimo}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="text" v-model="infoTipoMoneda[0].acronimo" class="form-control">
                    </b-col>
                </b-row>
                <md-dialog-actions class="mt-3">
                    <b-col cols="7" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="3" class="text-right">
                        <md-button class="md-primary" @click="guardarTipoMoneda">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteTipoMoneda" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import TipoMoneda from '../../../services/TipoMoneda';
import InacticaItem from '../../utils/InacticaItem.vue';

export default {
    name : 'Editar',
    props: ['modEditarTipoMoneda','infoTipoMoneda'],
    components:{InacticaItem},
    data: () => ({
        deleteTipoMoneda : false,
        idTipoMoneda : null
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear tipo moneda',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    acronimo : 'Acrónimo',
                    save : 'Guardar',
                    close : 'Cerrar',
                    delete : 'Eliminar'
                }
            }else{
                return {
                    title : 'Create currency type',
                    codigo : 'Code',
                    descripcion : 'Description',
                    acronimo : 'Acronym',
                    save : 'Save',
                    close : 'Close',
                    delete : 'Delete'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalDelet(){
            this.deleteTipoMoneda = false
        },
        guardarTipoMoneda(){
            const dataForm = [
                this.infoTipoMoneda[0].moneda,
                this.infoTipoMoneda[0].descripcion,
                this.infoTipoMoneda[0].acronimo
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                let info = {
                    'id'            :   this.infoTipoMoneda[0].id,
                    'descripcion'   :   this.infoTipoMoneda[0].descripcion,
                    'acronimo'      :   this.infoTipoMoneda[0].acronimo,
                    'idUser'        :   this.$store.state.userId
                }   
                // console.log(info);
                TipoMoneda.updateTipoMonedaById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo moneda ya existe.')
                        return
                    }
                })
                .catch((err) => console.log(err))
            }
        },
        eliminaRegistro(){
            this.idTipoMoneda = this.infoTipoMoneda[0].id
            this.deleteTipoMoneda = true
        },
        confirmInactivate(){
            TipoMoneda.deleteTipoMoneda(this.idTipoMoneda)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()                
                }
            })
            .catch((error) => error)
        }
    }
}
</script>

<style>

</style>